import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { WithStyleInput } from "./withStyleInput";

const InputField = ({ label, classes, ...props }) => {
  const ref = useRef(null);

  return (
    <>
      <Typography className={classes.title}>{label}</Typography>
      <div className={classes.inputContainer}>
        <WithStyleInput
          ref={ref}
          margin="normal"
          variant="outlined"
          {...props}
        />
      </div>
    </>
  );
};

InputField.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};

export default InputField;
